import chargingAdapterSvg from '!!raw-loader!../assets/charging-adapter.svg'; // eslint-disable-line
import chargingBaseSvg from '!!raw-loader!../assets/charging-base.svg'; // eslint-disable-line
import probeSvg from '!!raw-loader!../assets/iq.svg'; // eslint-disable-line
import { styled } from 'css-literal-loader/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import withProps from 'recompose/withProps';
import Layout from '@4c/layout';

import PageSegment from './PageSegment';

const Container = styled(Layout, null, "Container", require("./WhatsInTheBoxSegment-Container.module.scss"), "container", "container");

const Component = withProps({ direction: 'column', align: 'center' })(
  styled(Layout, null, "Component", require("./WhatsInTheBoxSegment-Component.module.scss"), "component", "component"),
);

const propTypes = {};

function WhatsInTheBoxSegment() {
  return (
    <PageSegment theme="light" align="center">
      <PageSegment.Heading>
        <FormattedMessage
          id="whatsInTheBox.heading"
          defaultMessage="In the box."
        />
      </PageSegment.Heading>
      <PageSegment.Content maxWidthMd>
        <Container>
          <Component pad={4}>
            <span dangerouslySetInnerHTML={{ __html: probeSvg }} />
            <header>
              <FormattedMessage
                id="whatsInTheBox.iqDevice"
                defaultMessage="Butterfly iQ"
              />
            </header>
          </Component>
          <Component pad={4}>
            <span dangerouslySetInnerHTML={{ __html: chargingBaseSvg }} />
            <header>
              <FormattedMessage
                id="whatsInTheBox.chargingBase"
                defaultMessage="Charging Base"
              />
            </header>
          </Component>
          <Component pad={4}>
            <span dangerouslySetInnerHTML={{ __html: chargingAdapterSvg }} />
            <header>
              <FormattedMessage
                id="whatsInTheBox.wires"
                defaultMessage="Charge Cable & Wall Plug"
              />
            </header>
          </Component>
        </Container>
      </PageSegment.Content>
    </PageSegment>
  );
}

WhatsInTheBoxSegment.propTypes = propTypes;

export default WhatsInTheBoxSegment;
